interface StanceBarProps {
  support: number;
  oppose: number;
  neutral: number;
  compact?: boolean;
}

export default function StanceBar({ support, oppose, neutral, compact = false }: StanceBarProps) {
  return (
    <div className="w-full">
      <div className={`flex w-full overflow-hidden rounded-full bg-background-200 ${compact ? 'h-1.5' : 'h-2.5'}`}>
        <span style={{ width: `${support}%` }} className="bg-secondary-500" />
        <span style={{ width: `${neutral}%` }} className="bg-background-400" />
        <span style={{ width: `${oppose}%` }} className="bg-primary-500" />
      </div>
      {!compact && (
        <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-1 text-xs text-foreground-600">
          <span className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-secondary-500" />倾向支持 {support}%
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-background-400" />观望 {neutral}%
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-primary-500" />持保留 {oppose}%
          </span>
        </div>
      )}
    </div>
  );
}